import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../services/auth.service";
import { AccessControlService } from "../services/access-control.service";
import * as moment from "moment";
import { SharedService } from "../shared-service/shared.service";
import { BsModalService } from "ngx-bootstrap";
// declare var $: any
@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.css"],
})
export class NavBarComponent implements OnInit {
  org_code: any;
  resp_org_code: any;
  org_name: any;
  resp_org_name: any;
  username: any;
  role_name: any;
  user_id: any;
  savemodel: any = {};
  currentuser_loginId: any;
  showSwitch: boolean = false;
  config = { backdrop: true, ignoreBackdropClick: true };
  modalRef: any;
  clientList = [];
  selectedClient: any;
  constructor(
    private router: Router,
    private toastrService: ToastrService,
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private accessControlService: AccessControlService,
    private sharedService: SharedService,
    private modalService: BsModalService
  ) {}
  toggleDropdown() {}
  ngOnInit() {
    // this.toggleDropdown();
    this.org_name = localStorage.getItem("org_name");
    var Isadmin = localStorage.getItem("IsAdmin");
    this.username = localStorage.getItem("username");
    this.user_id = localStorage.getItem("user_id");
    this.currentuser_loginId = localStorage.getItem("user_id");
    let client = localStorage.getItem("authClients");
    let authClients = client ? JSON.parse(client) : null;
    this.showSwitch = authClients && authClients.length > 1; //element 1 is available for all
    this.clientList = authClients;
  }

  getLoginStatebyId() {
    this.authService.getLoginStatebyId(this.currentuser_loginId).subscribe(
      (res) => {
        this.savemodel = res;
      },
      (error) => {},
      () => {}
    );
  }
  smoothlyMenu() {
    if (
      !document
        .getElementsByTagName("body")[0]
        .classList.contains("mini-navbar") ||
      document.getElementsByTagName("body")[0].classList.contains("body-small")
    ) {
      document.getElementById("side-menu").style.display = "none";
      setTimeout(function () {
        $(<any>document.getElementById("side-menu")).fadeIn(400);
      }, 200);
    } else if (
      document
        .getElementsByTagName("body")[0]
        .classList.contains("fixed-sidebar")
    ) {
      document.getElementById("side-menu").style.display = "none";
      setTimeout(function () {
        $(<any>document.getElementById("side-menu")).fadeIn(400);
      }, 100);
    } else {
      document.getElementById("side-menu").removeAttribute("style");
    }
  }
  toggleNavigation(): void {
    document.getElementsByTagName("body")[0].classList.toggle("mini-navbar");
    this.smoothlyMenu();
  }
  logout() {
    this.authService.logout().subscribe()
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("role_name");
    localStorage.removeItem("passwordPolicy");
    localStorage.removeItem("username");
    localStorage.removeItem("org_name");
    sessionStorage.clear();
    this.toastrService.success("Logged Out Successfully");
    (<any>document.getElementsByClassName("theme-config")[0]).hidden = true;
    this.sharedService.tokenExpiredEvent.next("changed");
    this.removeThemeConfig();
    this.router.navigate(["/login"]);
  }
  public get loggedIn(): boolean {
    return localStorage.getItem("token") !== null;
  }
  removeThemeConfig() {
    // $(function () {
    //   $('body').removeClass()
    // })
  }
  openModal(template: TemplateRef<any>) {
    this.selectedClient = localStorage.getItem("org_id");
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.modalRef = this.modalService.show(template, config);
  }
  closeModel() {
    this.modalRef.hide();
  }
  onSwitch() {
    localStorage.setItem("org_id", this.selectedClient);
    let client = this.clientList.find((x) => x._id == this.selectedClient);
    this.username = this.org_name = client.organization_name;
    localStorage.setItem("org_name", client.organization_name);
    localStorage.setItem("user_id", client._id);

    this.toastrService.success(
      `Switched to ${client.organization_name} successfully.`
    );
    this.modalRef.hide();
    this.refresh();
  }
  refresh() {
    let type = localStorage.getItem("type");
    if (type === "1")
      this.router.navigate([
        localStorage.getItem("org_name").toLowerCase().replace(/''/g, "-") +
          "/dashboard",
      ]);
    else {
      this.router.navigate(["/dashboard"]);
    }
  }
}
